import React, { useCallback } from 'react'
import MediaList from 'components/partials/MediaList'
import MediaImage from 'components/partials/MediaImage'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'

function OrganisationTemplate({ ...doc }) {
  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <OrganisationTable {...doc} />
      ) : (
        <OrganisationTeaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

export default OrganisationTemplate


function OrganisationTable({
  image_url,
  title,
  url,
  _click,
  email,
  parent_organization,
}) {
  const { trackResultClick } = useClickLogger(_click, url);

  return (
    <tr onClick={trackResultClick} style={{ cursor: 'pointer' }}>
      <td>
        <div className="media">
          {image_url && <MediaImage src={image_url} modifierClasses="thumbnail--rounded" />}
          <MediaContent>
            <Link href={url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
          </MediaContent>
        </div>
      </td>
      <td>
        {parent_organization && (
          <Description text={parent_organization} />
        )}
      </td>
      <td>
        {email && (
          <a className="link u-inline-block"
            href={`mailto:${  [].concat(email).slice(0, 1).shift()}`}
          >
            {email}
            <IconArrowRight />
          </a>
        )}
      </td>
    </tr>
  )
}

function OrganisationTeaser({
  image_url,
  title,
  url,
  email,
  _click,
  parent_organization,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <MediaList onClick={trackResultClick}>
      {image_url && <MediaImage src={image_url} modifierClasses="thumbnail--rounded" />}
      <MediaContent modifierClasses="u-max-width-full">
        <Link href={url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>

        {parent_organization && (
          <Description
            modifierClasses='u-mt-25'
            text={parent_organization}
          />
        )}

        {email && (
          <div className="u-mt-25">
            {email && (
              <a className="link u-inline-block"
                href={`mailto:${  [].concat(email).slice(0, 1).shift()}`}
              >
                {email}
              </a>
            )}
          </div>
        )}

        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
  )
}
